// ** Core JWT Import
import getJwt from "@src/@core/auth/jwt/getJwt"

const { jwt } = getJwt({})

export default jwt
